import * as React from "react";
import { Redirect } from "react-router-dom";

const GotoBanks: React.FC = () => <Redirect to="/banks" />;

export default GotoBanks;
